import { RequirePermission } from '@saniplus/ui';
import type { RouteObject } from 'react-router';

import { PermissionFallback } from '../../components/shared/PermissionFallback';

/**
 * A24 — `/audit`, gated on `audit:read` (an admin-only permission, D-02).
 *
 * The guard wraps the route rather than the page, so a supervisor never reaches
 * the fetch: the API scopes them out and would answer 404 anyway, and a screen
 * that flashes a toolbar before emptying reads as a bug rather than a refusal.
 *
 * The fallback is a rendered explanation, not a redirect — silently sending
 * someone to the dashboard is how a working link comes to look broken.
 *
 * Exported as an array for the integrator to splice into `app/router.tsx` under
 * the authenticated shell; this module knows nothing about its parents.
 */
export const routes: RouteObject[] = [
  {
    path: '/audit',
    element: <RequirePermission permission="audit:read" fallback={<PermissionFallback />} />,
    children: [
      {
        index: true,
        lazy: async () => ({ Component: (await import('./AuditPage')).AuditPage }),
      },
    ],
  },
];
